import { render, staticRenderFns } from "./DeliveryPointKeyOwnersDialog.vue?vue&type=template&id=3f942847"
import script from "./DeliveryPointKeyOwnersDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryPointKeyOwnersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports